<template>
  <vbt-content-box
    :loading-error="loadingError"
    :loading="isLoading"
    show-bottom-bar
    title="Settings"
  >
    <v-layout>
      <v-flex sm8>
        <v-layout column>
          <v-text-field
            v-model.trim="settings.inkRouterApiClient"
            label="InkRouter Api Client"
            class="mt-4"
          />
          <v-text-field
            v-model.trim="settings.inkRouterApiKey"
            label="InkRouter Api Key"
          />
          <v-text-field
            v-model.trim="settings.serviceUsername"
            label="Service Username"
          />
          <v-text-field
            v-model.trim="settings.servicePassword"
            :type="showPassword ? 'text' : 'password'"
            label="Service Password"
          >
            <template #append>
              <v-btn
                icon
                @mousedown.left="showPassword = !showPassword"
                @mouseup.left="showPassword = !showPassword"
                @mouseleave="showPassword = false"
              >
                <v-icon>
                  {{ showPassword ? 'visibility_off' : 'visibility' }}
                </v-icon>
              </v-btn>
            </template>
          </v-text-field>
          <v-text-field
            v-model.trim="settings.equipmentQueue"
            label="Equipment Queue"
          />

          <v-layout justify-space-between>
            <strong>
              Label Printers
            </strong>

            <v-btn
              x-small
              outlined
              color="success"
              @click="addNewLabelPrinter"
            >
              Add new
            </v-btn>
          </v-layout>

          <v-divider class="my-2" />

          <v-layout
            v-for="(labelPrinter, i) in settings.labelPrinters || []"
            :key="i"
            align-center
          >
            <v-flex sm4>
              <v-text-field
                v-model.trim="labelPrinter.id"
                label="ID"
              />
            </v-flex>

            <v-flex
              class="px-3"
              sm4
            >
              <v-text-field
                v-model.trim="labelPrinter.name"
                label="Name"
              />
            </v-flex>

            <v-flex
              class="pr-3"
              sm4
            >
              <v-text-field
                v-model.trim="labelPrinter.url"
                label="URL"
              />
            </v-flex>

            <v-btn
              icon
              small
              color="error"
              @click="removeLabelPrinter(labelPrinter)"
            >
              <v-icon>
                remove_circle
              </v-icon>
            </v-btn>
          </v-layout>
        </v-layout>
      </v-flex>
    </v-layout>
    <v-layout
      slot="footer"
      justify-end
    >
      <v-blacker-button
        :loading="isLoading"
        :disabled="loadingError.show"
        class="mr-2"
        small
        text
        @click="$_fetchData"
      >
        Reset
      </v-blacker-button>
      <v-blacker-button
        :loading="isLoading"
        :disabled="loadingError.show"
        color="success"
        small
        @click="updateSettings"
      >
        Update
      </v-blacker-button>
    </v-layout>
  </vbt-content-box>
</template>

<script>
import { mapState, mapActions } from 'vuex';

import { useDataLoading } from '@mixins/factories';

import { wrapToLoadingFn } from '@helpers';

import { namespace as LocationsNamespace } from '@store/modules/locations.types';

import { namespace as SettingsNamespace, ActionTypes as SettingsActionTypes } from '../store.types';

import SettingsApiService from '../_services/settings.api.service';

const dataLoadingOptions = {
  getterName: SettingsActionTypes.GET_SETTINGS,
  parameterize: true,
  searchable: false,
  paged: false,
};

export default {
  name: 'KernelSettings',

  mixins: [
    useDataLoading(dataLoadingOptions),
  ],

  data() {
    return {
      showPassword: false,
    };
  },

  computed: {
    ...mapState(LocationsNamespace, ['suffix']),

    ...mapState(SettingsNamespace, ['settings']),
  },

  methods: {
    ...mapActions(SettingsNamespace, [SettingsActionTypes.GET_SETTINGS]),

    addNewLabelPrinter() {
      if (!this.settings.labelPrinters) {
        this.settings.labelPrinters = [];
      }

      this.settings.labelPrinters.push({ id: '', name: '', url: '' });
    },

    removeLabelPrinter(labelPrinter) {
      this.settings.labelPrinters.splice(this.settings.labelPrinters.indexOf(labelPrinter), 1);
    },

    updateSettings() {
      this.wrapToLoadingFn({
        req: SettingsApiService.updateSettings.bind({}, {
          suffix: this.suffix,
          data: this.settings,
        }),
        onSuccess: () => {
          this.$VBlackerTheme.notification.success('Settings successfully updated');
        },
      });
    },

    wrapToLoadingFn,
  },
};
</script>
